module.exports = __webpack_public_path__ + "img/icon-blue-right-arrow.63d1df08.svg";